import type { EventDetails } from "@/modules/eventDetails/client/api/types"
import type { FunctionComponent } from "react"

import Image from "next/image"
import { useParams } from "next/navigation"

import { Heading } from "@jobteaser/spark/components/Heading"
import { RichText } from "@jobteaser/ui-kit/components/RichText/RichText"

import { useEventDetailsData } from "@/modules/eventDetails/client/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import bodyStyles from "./Body.module.css"
import styles from "./Description.module.css"

export const Description: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  const { description, coverUrl } = event as EventDetails

  return (
    <>
      {coverUrl && (
        <Image
          className={styles.image}
          src={coverUrl}
          alt=""
          priority
          width={800}
          height={396}
          data-testid="event-details-hero-image"
        />
      )}
      <Heading as="h2" variant="title2" className={bodyStyles.title} weight="bold" data-testid="event-details-agenda">
        {t("event_details.body.agenda")}
      </Heading>
      <RichText
        className={styles.description}
        data-testid="event-details-description"
        allowIframeTag
        allowTargetAttribute
      >
        {description}
      </RichText>
    </>
  )
}
